<script setup lang="ts">
import { Table as ATable, Button } from 'ant-design-vue';
import type { SizeType } from 'ant-design-vue/lib/config-provider';

import type { FileContentFragmentFragment, FileFragmentFragment } from '@/graphql/generated/graphql';
import type { TableColumns } from '@/ui/Table/tableProperties';

const props = defineProps<{
  dataSource: FileContentFragmentFragment[];
  file: FileFragmentFragment;
  tableDensity: SizeType;
  onSelect?: (data: FileContentFragmentFragment) => void;
}>();

const columns = computed(() => {
  const cols: TableColumns = [
    {
      title: 'id',
      dataIndex: 'id',
      key: 'id',
    },
    {
      title: 'Content',
      dataIndex: 'content',
      key: 'content',
    },
    {
      title: 'Content Type',
      dataIndex: 'content_type',
      key: 'content_type',
    },
  ];

  if (props.onSelect) {
    cols.push({
      title: 'Select',
      dataIndex: 'onSelect',
      key: 'onSelect',
    });
  }

  return cols;
});
</script>

<template>
  <ATable
    :data-source="dataSource"
    :columns="columns"
    :row-key="(record) => record.id"
    :pagination="false"
    :size="tableDensity"
  >
    <template #bodyCell="{ record, column, value }">
      <FileContentViewModal
        v-if="column.key === 'content'"
        :file-content="(record as FileContentFragmentFragment)"
        :file="file"
      />
      <template v-else-if="column.key === 'onSelect'">
        <Button type="primary" @click="onSelect!(record as FileContentFragmentFragment)">
          Select
        </Button>
      </template>
      <template v-else>
        {{ value }}
      </template>
    </template>
  </ATable>
</template>